import { render, staticRenderFns } from "./QCarrierDataTable.vue?vue&type=template&id=3c28dc1e&scoped=true&"
import script from "./QCarrierDataTable.vue?vue&type=script&lang=js&"
export * from "./QCarrierDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QCarrierDataTable.vue?vue&type=style&index=0&id=3c28dc1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28dc1e",
  null
  
)

export default component.exports